import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CoreModule } from '../../../core/core.module';
import { TranslateModule } from '../../../services/translate/translate.module';
import { CustomAccordionModule } from '../../../shared-components/custom-accordion/custom-accordion.module';
import { FAQShowcaseComponent } from './faq-showcase.component';

@NgModule({
	imports: [CommonModule, CoreModule, FormsModule, TranslateModule, CustomAccordionModule],
	declarations: [FAQShowcaseComponent],
	exports: [FAQShowcaseComponent],
})
export class FaqShowcaseModule {}
